import React from 'react';
import VideoStyles from './styles';
import PropTypes from 'prop-types';

const Video = ({ src }) => (
	<VideoStyles>
		<video
			preload="true"
			autoPlay="autoplay"
			loop="loop"
			webkit-playsinline="true"
			playsinline="true"
			muted="muted"
			controls
			key={src}
		>
			<source src={src} type="video/mp4" id="videoA" />
		</video>
	</VideoStyles>
);

export default Video;

Video.propTypes = {
	src: PropTypes.string.isRequired
};
